import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logoMedical from "../../assets/logo-medical.png";
import martina from "../../assets/martina.png";
import NextButton from "../../components/NextButton";
import PatientAvatar from "../../components/PatientAvatar";
import { useGameTexts } from "../../hooks/useGameTexts";
import { ROUTES } from "../../utils/constants";
import { getScenarioByScreen } from "../../utils/helpers";

function Scenario7End({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const group = useSelector((state) => state.group);
	const scenarioNum = getScenarioByScreen(location.pathname);
	const { texts, ready: textsReady } = useGameTexts(group?.game);
	const content = texts["scenario7-end.content"] ?? "";

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} />
				</div>
				<div className="row d-flex justify-content-center align-items-center mt-5">
					<div className="col-6">
						<div className="d-flex flex-column align-items-center">
							<PatientAvatar gameId={group?.game} defaultSrc={martina} width={90} />
							<div
								className="txt20 bold txt-yellow-light mt-4 text-center"
								style={{ lineHeight: "30px" }}
								dangerouslySetInnerHTML={{ __html: textsReady ? content : "Cargando..." }}
							/>
						</div>
					</div>
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "8vh",
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton
						navigateTo={ROUTES.TRANSITION_SCENARIOS}
						activeScenario={scenarioNum + 1}
					/>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario7End);
